const TagsFilterFlyout = {
  parts: [
    'container',
    'header',
    'headerTop',
    'title',
    'clearButton',
    'content',
    'accordion',
    'accordionItem',
    'accordionButton',
    'accordionPanel',
    'categoryTitle',
    'appliedFiltersTitle',
    'arrowIcon',
    'appliedFiltersContainer',
    'filterPill',
    'filterPillText',
    'closeIconButton',
    'closeIcon',
    'option'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      w: {base: 'full', md: '290px'},
      flex: {base: '0 0 100%', md: '0 0 290px'},
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 8,
      position: 'relative',
    },

    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 1.5,
      alignSelf: 'stretch',
      position: 'relative',
    },

    headerTop: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      alignSelf: 'stretch',
      position: 'relative',
    },

    title: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      letterSpacing: '-0.22px',
      position: 'relative',
      m: 0,
    },

    clearButton: {
      color: 'brandColors.greyscale70',
      fontFamily: 'heading',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
      textDecoration: 'underline',
      bg: 'transparent',
      p: 0,
      minW: 'auto',
      h: 'auto',
      _hover: {
        bg: 'transparent',
        color: 'brandColors.greyscale90',
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brandColors.primaryDarkLinen',
        outlineOffset: '2px',
      },
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 30,
      alignSelf: 'stretch',
      position: 'relative',
    },

    accordion: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      border: 'none',
    },

    accordionItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      border: 'none',
      borderTop: '1px solid',
      borderColor: 'brandColors.greyscale10',
      sx: {
        ' .chakra-collapse': {
          w: 'full',
        },
      },
    },

    accordionButton: {
      display: 'flex',
      py: 6,
      px: 0,
      justifyContent: 'space-between',
      alignItems: 'center',
      alignSelf: 'stretch',
      position: 'relative',
      _hover: {
        bg: 'transparent',
      },
    },

    accordionPanel: {
      display: 'flex',
      pb: 6,
      px: 0,
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 2.5,
      position: 'relative',
    },

    categoryTitle: {
      color: 'black',
      fontFamily: 'heading',
      fontSize: {base: 'lg', md: 'lg'},
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '160%',
      position: 'relative',
    },

    appliedFiltersTitle: {
      fontSize: 'xl',
      fontWeight: 'medium',
    },

    arrowIcon: {
      w: '13.333px',
      h: '13.333px',
      color: 'brandColors.primaryDarkLinen',
      transition: 'transform 0.2s',
      sx: {
        '[aria-expanded=true] &': {
          transform: 'rotate(180deg)',
        },
      },
    },

    appliedFiltersContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 2.5,
      position: 'relative',
      w: 'full',
      flexWrap: 'wrap',
    },

    filterPill: {
      display: 'flex',
      p: '8px 16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      borderRadius: '100px',
      border: '1px solid',
      borderColor: 'brandColors.linen03',
      bg: 'transparent',
      position: 'relative',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      _hover: {
        bg: 'brandColors.secondaryBG',
        borderColor: 'brandColors.primaryDarkLinen',
      },
    },

    filterPillText: {
      color: 'brandColors.greyscale',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
    },

    closeIconButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      p: 0,
      minW: 'auto',
      h: 'auto',
      bg: 'transparent',
      border: 'none',
      _hover: {
        opacity: 0.7,
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brandColors.primaryDarkLinen',
        outlineOffset: '2px',
        borderRadius: '4px',
      },
    },

    closeIcon: {
      w: 4,
      h: 4,
      color: '#32312F',
      flexShrink: 0,
    },

    option: {
      color: 'black',
      fontFamily: 'heading',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '160%',
      cursor: 'pointer',
      _hover: {
        color: 'brandColors.primaryDarkLinen',
      },
    },
  },
};

export default TagsFilterFlyout;
